export default __webpack_public_path__ + "static/media/video_and_console_games.cda845ac.jpeg";